// Height of the sticky header, change this if the height of the sticky header changes
export const STICKY_HEADER_HEIGHT = 60

// Height of the mini header added by the updated_pull_request_header flag
export const MINI_HEADER_HEIGHT = 48

// Margin top space to give a diff entry when scrolling
export const BASE_DIFF_MARGIN_TOP_PADDING = 10

// DOM id of the Overview merge box wrapper, used as a scroll anchor from other
// overview items (e.g. the For You "Merge is blocked" action).
export const OVERVIEW_MERGE_BOX_ANCHOR_ID = 'overview-merge-box'

// DOM id of the Overview comments section, used as a scroll anchor from the mini merge status.
export const OVERVIEW_COMMENTS_ANCHOR_ID = 'overview-comments'

export const COMMENTS_VIEW_MODE_SEARCH_PARAM = 'comments:mode'

export const STACKS_FEEDBACK_SUBJECT = 'stacks-feedback'

// Keep in sync with PullRequests::FeatureFeedback::Registry and the Overview feedback Kusto dimension.
export const OVERVIEW_FEEDBACK_SUBJECT = 'overview-feedback'

// The backend limit is unlikely to change, so mirror it here for now.
// If it changes, we can pass it from the backend instead.
export const MAX_STACK_SIZE = 100

export const PROOF_OF_PRESENCE_AUTHENTICATION_FAILED_EVENT = 'proof-of-presence-authentication-failed'
export const PROOF_OF_PRESENCE_AUTHENTICATION_SUCCEEDED_EVENT = 'proof-of-presence-authentication-succeeded'

export type ProofOfPresenceAuthenticationEventDetail = {
  pullRequestPath: string
  requiredLevel?: 'reauth' | 'mfa' | null
  returnFocusTarget?: HTMLButtonElement | null
}
